module.exports = __webpack_public_path__ + "static/img/coupon.a14cdd1f.png";